<strong class="items-center cursor-pointer flex whitespace-nowrap" (click)="onChangeSort()">
	<ng-content></ng-content>
	<fa-icon class="ml-1" [fixedWidth]="true" [icon]="sortIcon"></fa-icon>
</strong>
